import type { KeyboardEvent } from 'react';

/**
 * 클릭 카드용 접근성 props — 클릭 + 키보드(Enter/Space) 활성화.
 *
 * `<button>`으로 감쌀 수 없는 클릭 영역(카드 전체가 클릭 타깃인 경우)에 스프레드해서 쓴다.
 * 내부에 또 다른 버튼/링크가 있는 **중첩 인터랙티브 카드에는 쓰지 않는다**(구조 재설계 대상).
 */
export function clickable(onClick: () => void) {
  return {
    role: 'button' as const,
    tabIndex: 0,
    onClick,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    },
  };
}
